$(function () {
    const passwordConfirmModal = $('#passwordConfirmModal');
    const form = $('form.passwordConfirm');
    const isUserVerify = form.attr('data-is-user-verify');
    const isUserConfirm = form.attr('data-is-user-confirm');
    const authUserId = form.attr('data-user');
    const formSubmitButton = $('button[type="submit"]', form)
    const passwordConfirmModalFormSubmitButton = $('button[type="submit"]', passwordConfirmModal);
    let passwordConfirmModalUserSelect = $('select[name="user_id"]', passwordConfirmModal);

    if (isUserConfirm === '1' && passwordConfirmModal.length !== 0) {
        form.append('<input type="hidden" name="user_id">');
        if (isUserVerify === '1') {
            form.append('<input type="hidden" name="user_password">');
        }
    }

    formSubmitButton.click(function (e) {
        if (form[0].checkValidity() === false) {
            return true;
        }

        e.preventDefault();

        formSubmitButton.attr('disabled', 'disabled');
        if (isUserConfirm === '1') {
            passwordConfirmModal.modal();
            return false;
        } else {
            form.submit();
        }
    });

    passwordConfirmModalUserSelect.change(function () {
        const passwordInput = $('input[name="user_password"]', form);
        const passwordRow = $('div[name="password_row"]', passwordConfirmModal);

        if (isUserVerify === '1') {
            if (passwordRow.length === 0) {
                appendAttributes();
                removeDisableAttribute();
            }
        } else {
            if (passwordConfirmModalUserSelect.val() === '1' && passwordConfirmModalUserSelect.val() !== authUserId && passwordRow.length === 0) {
                appendAttributes();
                removeDisableAttribute();
            } else {
                passwordInput.remove();
                passwordRow.remove();
            }
        }
    });

    form.submit(function (e) {
        if ($(this).hasClass('ajax')) {
            $.post($(form).attr('action'), $(form).serialize(), function (response) {
                passwordConfirmModal.modal('hide');

                if (response.alert) {
                    PNotify.success({
                        text: response.alert.message
                    })
                }

                if (response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    window.location.reload();
                }
            }).fail(function (response) {
                if (response.responseJSON.alert) {
                    PNotify.error({
                        text: response.responseJSON.alert.message
                    })
                } else if (response.status === 403) {
                    PNotify.error({
                        text: response.responseJSON.message
                    });
                } else {
                    var errorMessage = '';
                    for (const [key, value] of Object.entries(response.responseJSON.errors)) {
                        errorMessage += value + "\n";
                    }

                    PNotify.error({
                        title: 'Formunuzda aşağıdaki hatalar oluştu!',
                        text: errorMessage
                    });
                }
            }).always(function () {
                formSubmitButton.removeAttr('disabled');
            });

            return false;
        }
    });

    passwordConfirmModalFormSubmitButton.click(function () {
        $(this).attr('disabled', 'disabled');
        $('form', passwordConfirmModal).submit();
    });

    removeDisableAttribute();

    $('form', passwordConfirmModal).submit(function () {
        $('input[name="user_id"]', form).val($('select[name="user_id"]', this).val());
        if (isUserVerify === '1' || passwordConfirmModalUserSelect.val() === '1') {
            $('input[name="user_password"]', form).val($('input[name="user_password"]', this).val());
        }
        form.submit();

        return false;
    });

    $(passwordConfirmModal).on('shown.bs.modal', function () {
        passwordConfirmModalUserSelect.trigger('change');
    });

    $(passwordConfirmModal).on('hidden.bs.modal', function () {
        formSubmitButton.removeAttr('disabled');
        passwordConfirmModalFormSubmitButton.removeAttr('disabled');
        $('div[name="password_row"]', passwordConfirmModal).remove();
    });

    function appendAttributes() {
        form.append('<input type="hidden" name="user_password">');
        $('.modal-body', passwordConfirmModal).append(
            '<div class="row" name="password_row">' +
            '<div class="col mb-3">' +
            '<label class="col-form-label">Şifre:</label>' +
            '<input class="form-control" type="text" minlength="8" maxlength="32" required ' +
            'onfocus="this.type=\'password\';" name="user_password"/>' +
            '</div>' +
            '</div>'
        );
    }

    function removeDisableAttribute() {
        let passwordConfirmModalUserPassword = $('input[name="user_password"]', passwordConfirmModal);
        passwordConfirmModalUserPassword.bind("keyup", function (event) {
            let keyCode = event.keyCode;
            if (keyCode === 8) {
                passwordConfirmModalFormSubmitButton.removeAttr('disabled');
            }
        });
    }
});
